export default "__VITE_ASSET__CGDtGAgn__"